import ReactAppController from "./react_app_controller"

export default class extends ReactAppController {

    constructor(props) {
        super(props)
        this.name = "smart_home_app_controller"
    }

    renderApp() {
        Turbo.cache.clear()
        const appConfig = {
            buildingId: this.element.getAttribute("data-building-id"),
            locale: this.element.getAttribute("data-locale")
        }
        this.app = __bmx__initSmartHomeApp(this.element, appConfig)
    }
}
